import { DatePicker, Descriptions, Modal, Select, Tag, Typography } from 'antd';
import PropTypes from "prop-types";

import React, { useEffect, useMemo, useState } from 'react'
import { saveOffreIndemnisation, updateAyantDroitIndemnisation, updateOffreIndemnisation } from '../../../hooks/useHooks';
import TextArea from 'antd/es/input/TextArea';
import { toast } from 'react-toastify';
import { UploadOutlined } from '@ant-design/icons';
import { formatIttValueForDisplay, frenchDate, getAgeFromSinistre, getIttUnitLabel, getPourcentageRepartition, getPrejudiceMoralBeneficiaireKey, getPrixRente, getValeurPointIP, numberOfDaysBetweenDates } from '../../../variables/functions';
import axiosInstance from '../../../variables/api/axiosInstance';
import { displayNumbers } from '../../../variables/numbersFunctions';
import AmountInputNumber from '../../../components/inputs/AmountInputNumber';
import { findPretiumLabel, mapPretiumDolorisOptions, selectApplicableSmig } from '../../../utils/paramHelpers';
import moment from 'moment';
const { Text } = Typography;

const AjouterOffre = (props) => {
    const [offre, setOffre] = useState({});
    const [isOffreModalVisible, setIsOffreModalVisible] = useState(false);
    const [addOffreLoading, setAddOffreLoading] = useState(false);
    const [expertises, setExpertises] = useState([]);
    const [victimes, setVictimes] = useState([]);
    const [expertise, setExpertise] = useState({});
    const [incapaciteTemporaire, setIncapaciteTemporaire] = useState(0);
    const [prejudicePhysiologique, setPrejudicePhysiologique] = useState(0);
    const [prejudiceEconomique, setPrejudiceEconomique] = useState(0);
    const [prejudiceMoral, setPrejudiceMoral] = useState(0);
    const [incapacitePermanente, setIncapacitePermanente] = useState(0);
    const [assistanceTiercePersonne, setAssistanceTiercePersonne] = useState(0);
    const [pretiumDoloris, setPretiumDoloris] = useState(0);
    const [prejudiceEsthetique, setPrejudiceEsthetique] = useState(0);
    const [prejudiceScolaire, setPrejudiceScolaire] = useState(0);
    const [prejudiceCarriere, setPrejudiceCarriere] = useState(0);
    const [prejudiceLeses, setPrejudiceLeses] = useState(0);
    const [totalIndemnisation, setTotalIndemnisation] = useState(0);
    const [provisions, setProvisions] = useState([]);
    const [totalProvisions, setTotalProvisions] = useState(0);
    const [revenuACapitaliserDesCoinjoints, setRevenuACapitaliserDesCoinjoints] = useState(0);
    const [revenuACapitaliserDesAscendants, setRevenuACapitaliserDesAscendants] = useState(0);
    const [revenuACapitaliserDesEnfants, setRevenuACapitaliserDesEnfants] = useState(0);
    const [cleDesConjoints, setCleDesCoinjoints] = useState(150);
    const [nbreConjoints, setNbreConjoints] = useState(0);
    // const [nbreEnfants, setNbreEnfants] = useState(0);
    // const [nbreAscendants, setNbreAscendants] = useState(0);
    const [plafondPrejudiceEconomiqueAD, setPlafondPrejudiceEconomiqueAD] = useState(0);
    const [plafondPrejudiceMoralAD, setPlafondPrejudiceMoralAD] = useState(0);
    const [plafondPrejudiceMoralVeuveAD, setPlafondPrejudiceMoralVeuveAD] = useState(0);
    const [totalPrejudiceMoralVeuveAD, setTotalPrejudiceMoralVeuveAD] = useState(0);
    const [totalPrejudiceEconomique, setTotalPrejudiceEconomique] = useState(0);
    const [totalPrejudiceMoral, setTotalPrejudiceMoral] = useState(0);
    const [victime, setVictime] = useState({});
    const [responsabilite, setResponsabilite] = useState(100);
    const [revenuProfessionelMensuelAvantAccident, setRevenuProfessionelMensuelAvantAccident] = useState(0);
    const [prixRentes, setPrixRentes] = useState({});
    const [totalAPayer, setTotalAPayer] = useState(0);
    const [prixRentesLoading, setPrixRentesLoading] = useState(false);

    const [smig, setSmig] = useState(52500);
    const [tauxIP, setTauxIP] = useState(0);
    const [prixFrancReste, setPrixFrancReste] = useState(0);
    const [pretiumDolorisOptions, setPretiumDolorisOptions] = useState([]);
    const [ayantsDroits, setAyantsDroits] = useState([]);

    const isPartnerQualite = (qualite = "") => {
        const upper = (qualite || "").toUpperCase();
        return upper.startsWith("CONJOINT");
    };
    const plafondPe = 10 * smig * 12;

    const handleChange = (e, nom) => {
        if (nom) {
            setOffre({ ...offre, [nom]: e });
        } else {
            const { name, value } = e.target;
            setOffre({ ...offre, [name]: value });
        }
    };

    useEffect(() => {
        setIsOffreModalVisible(props.open);
        setOffre({ ...offre, ["montantFraisMedicaux"]: 0 });
    }, [props.open]);

    useEffect(() => {
        if (!isOffreModalVisible) {
            props.setOpen(false);
        }
    }, [isOffreModalVisible]);

    useEffect(() => {
        if (!victime?.ayantsDroit?.length) {
            setPrixRentes({});
            return;
        }

        const fetchPrixRentes = async () => {
            setPrixRentesLoading(true);
            try {
                const entries = await Promise.all(
                    victime.ayantsDroit.map(async (ad, index) => {
                        const quality = ad?.qualite?.toUpperCase().startsWith("PERE") || ad?.qualite.toUpperCase().startsWith("MERE") ? 100 : ad?.qualite?.startsWith("ENFANT") ? 25 : isPartnerQualite(ad?.qualite) ? 100 : 0;
                        const age = getAgeFromSinistre(ad?.dateNaissance, props?.sinistre?.dateSinistre);
                        console.log("Fetching prix rente for ayant droit: ", ad?.prenom, ad?.nom, " age: ", age, " quality: ", quality);
                        const prix = await getPrixRente(age, ad?.genre, quality);
                        return [index, prix];
                    })
                );

                setPrixRentes(Object.fromEntries(entries));
            } catch (error) {
                console.error("Error fetching prix rentes:", error);
                setPrixRentes({});
            } finally {
                setPrixRentesLoading(false);
            }
        };

        fetchPrixRentes();
    }, [victime?.ayantsDroit]);

    useEffect(() => {
        if (props.edit) {
            console.log("Offrande: ", props.offre);
            setOffre(props.offre);
            setVictime(props?.offre?.victime);
            console.log("Before deal");

            dealWithOffer(props?.offre?.victime);
            console.log("La victime: ", props?.offre?.victime);

            axiosInstance?.get(`/api/expertise/victime/${props?.offre?.victime?.codeId}`).then((response) => {
                console.log("Expertise: ", response?.data);
                setExpertise(response?.data);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [props.edit]);

    useEffect(() => {
        let vict = [];
        if (props.expertises) {
            let exps = [];
            props.expertises.map((exp) => {
                exps.push(exp.beneficiaire);
            });
            vict.push(...exps.filter((vict) => vict.blesseSinistre));
            setExpertises(props.expertises);
            setRevenuProfessionelMensuelAvantAccident(expertises[0]?.beneficiaire?.revenuProfessionelMensuelAvantAccident);
        }
        let v = props?.sinistre?.victimes.filter(vic => vic.decesSinistre);
        vict.push(...v)
        setVictimes(vict);
    }, [props.expertises]);

    useEffect(() => {
        let isMounted = true;
        axiosInstance
            .get(`/api/pretium-doloris`)
            .then((res) => {
                if (!isMounted) {
                    return;
                }
                setPretiumDolorisOptions(mapPretiumDolorisOptions(res.data));
            })
            .catch((error) => {
                console.error('Erreur lors du chargement des prétium doloris:', error);
                if (isMounted) {
                    setPretiumDolorisOptions([]);
                }
            });

        return () => {
            isMounted = false;
        };
    }, []);

    useEffect(() => {
        if (victime?.decesSinistre) {
            const taux = props?.sinistre?.tauxResponsabilite ?? 100;
            console.log("Calcul total à payer avec taux: ", taux, "   Indeminsation: ", totalIndemnisation);
            const totalIndemResp = (totalIndemnisation * taux) / 100;
            console.log("Total indem resp: ", totalIndemResp);
            const totalFraisFuneraires = offre?.montantFraisFuneraires
                ? (parseFloat(offre.montantFraisFuneraires) * taux) / 100
                : 0;
            console.log("Total frais funeraires: ", totalFraisFuneraires);
            const totalFraisMedicaux = offre?.montantFraisMedicaux
                ? parseFloat(offre.montantFraisMedicaux)
                : 0;
            console.log("Total frais medicaux: ", totalFraisMedicaux);
            const provisions = totalProvisions ?? 0;
            console.log("Provisions: ", provisions);
            const total = totalIndemResp
                - provisions
                + totalFraisFuneraires
                + totalFraisMedicaux;

            setTotalAPayer(total);
        } else {
            setTotalAPayer((totalIndemnisation * responsabilite / 100) - totalProvisions);
        }
    }, [
        victime,
        totalIndemnisation,
        totalProvisions,
        offre?.montantFraisFuneraires,
        offre?.montantFraisMedicaux,
        props?.sinistre?.tauxResponsabilite
    ]);


    useEffect(() => {
        let isMounted = true;
        axiosInstance
            .get(`/api/smig`)
            .then((res) => {
                if (!isMounted) {
                    return;
                }
                const value = selectApplicableSmig(res.data, props?.sinistre);
                if (value) {
                    setSmig(value);
                }
            })
            .catch((error) => {
                console.error('Erreur lors du chargement du SMIG:', error);
            });

        return () => {
            isMounted = false;
        };
    }, [props?.sinistre]);

    const handleSubmit = async () => {
        try {

            const plafondFraisFuneraires = 2 * smig * 12;
            if (offre?.montantFraisFuneraires > plafondFraisFuneraires) {
                toast("Le montant des frais funeraires est supérieur au plafond autorisé!");
            } else {
                setAddOffreLoading(true);

                offre.montantFraisMedicaux = offre?.montantFraisMedicaux ? parseFloat(offre?.montantFraisMedicaux) : 0;
                if (victime?.blesseSinistre) {
                    offre.montantPrejudiceCarriere = prejudiceCarriere;
                    offre.montantPrejudiceLeses = prejudiceLeses;
                    offre.montantPrejudicePhysiologique = prejudicePhysiologique;
                    offre.montantPrejudiceScolaire = prejudiceScolaire;
                    offre.montantPretiumDoloris = pretiumDoloris;
                    offre.montantItt = incapaciteTemporaire;
                    offre.montantIpp = incapacitePermanente;
                    offre.assistanceTiercePersonne = assistanceTiercePersonne;
                    offre.montantPrejudiceEsthetique = prejudiceEsthetique;
                    offre.montantPrejudiceEconomique = prejudiceEconomique;
                    offre.montantPrejudiceMoral = prejudiceMoral;
                } else {
                    offre.montantPrejudiceMoral = totalPrejudiceMoral;
                    offre.montantPrejudiceEconomique = totalPrejudiceEconomique;
                }

                if (victime?.decesSinistre) {
                    offre.montantFraisFuneraires = offre?.montantFraisFuneraires ? parseFloat(offre?.montantFraisFuneraires) : 0;
                }

                offre.totalAPayer = totalAPayer;
                offre.totalIndemnites = parseFloat(totalIndemnisation);
                offre.victime = victime;
                offre.sinistre = props?.sinistre;
                console.log("Sinistre: ", props?.sinistre);
                if (totalAPayer > props?.sinistre?.sap) {
                    toast.error("Le montant de l'offre est supérieur au SAP du sinistre");
                    setAddOffreLoading(false);
                    return;
                }

                console.log('victime Offer ', offre);
                if (props.edit) {
                    const response = await updateOffreIndemnisation(offre)
                    console.log('response ', response);
                } else {
                    const response = await saveOffreIndemnisation(offre)
                    console.log('response ', response);
                }

                const resp = await updateAyantDroitIndemnisation(ayantsDroits);
                console.log("Response update ayants droits: ", resp);


                setIsOffreModalVisible(false);
                // setRefetch((previous) => !previous)
                toast.success('Offre enregistrée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                window.location.reload();
            }

        } catch
        (error) {
            toast.error('Une erreur est survenue', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            })
        } finally {
            setAddOffreLoading(false);
        }

    };

    const dealWithOffer = async (victimized) => {
        console.log("In deal");
        //Get all provisions
        axiosInstance.get(`/api/decaissement/provisions/${victimized?.personne?.codeId}`).then((res) => {
            // console.log("Provisions: ", res?.data);
            setProvisions(res?.data);
            let sumProvisions = res?.data?.reduce((a, b) => a + b?.montantGlobal, 0);
            setTotalProvisions(sumProvisions);

        }).catch(err => {
            console.log("err: ", err);
        });
        console.log("Victime: ", victimized, " ", props?.sinistre?.dateSinistre);

        if (victimized?.blesseSinistre) {
            let age1 = getAgeFromSinistre(victimized?.personne?.dateNaissance, props?.sinistre?.dateSinistre);
            let tip = getValeurPointIP(parseInt(expertise?.ipp), age1);
            setTauxIP(tip);
            let pfr = await getPrixRente(age1, victimized?.personne?.genre, 100);
            setPrixFrancReste(pfr);

            let rpaa = Math.min(victimized?.revenuProfessionelMensuelAvantAccident, (smig * 6 * 12));
            setRevenuProfessionelMensuelAvantAccident(rpaa);

            let it = expertise?.perceptionSalairePendantTraitement ? 0 : Math.abs(
                rpaa * (expertise?.itt - numberOfDaysBetweenDates(props?.sinistre?.dateSinistre?.split("T")[0], (victimized?.dateDernierSalaire?.split("T")[0] || expertise?.dateDernierSalaire?.split("T")[0]))) / 30
            );
            setIncapaciteTemporaire(it);
            let pp = 12 * smig * tauxIP * expertise?.ipp / 100;
            setPrejudicePhysiologique(pp);
            let pe = expertise?.ipp >= 50.0 && victimized?.perteRevenuProfessionelMensuelApresAccident ? Math.abs(Math.min(
                (
                    victimized?.perteRevenuProfessionelMensuelApresAccident * 12 * prixFrancReste
                ),
                plafondPe
            )) : 0;
            setPrejudiceEconomique(pe);
            let pm = expertise?.ipp > 80.0 ? 2 * smig * 12 : 0;
            setPrejudiceMoral(pm);
            setIncapacitePermanente(pp + pe + pm);
            let atp = expertise?.ipp > 80.0 && expertise?.besoinAssistance ? (pm + pe + pp) / 2 : 0;
            setAssistanceTiercePersonne(atp);
            let pd = expertise?.pretiumDoloris * smig * 12 / 100;
            setPretiumDoloris(pd);
            let pes = expertise?.prejudiceEsthetique * smig * 12 / 100;
            setPrejudiceEsthetique(pes);
            let ps = victimized?.montantBourseMensuelle && expertise?.prejudiceCarriere ? victimized?.montantBourseMensuelle * 12 : 0;
            setPrejudiceScolaire(ps);
            let pc = victimized?.revenuProfessionelMensuelAvantAccident && expertise?.prejudiceCarriere ? Math.min(victimized?.revenuProfessionelMensuelAvantAccident * 6, 36 * smig * 12) : 0;
            setPrejudiceCarriere(pc);
            let pl = expertise?.ipp >= 80.0 ? 2 * smig * 12 : 0;
            setPrejudiceLeses(pl);
            setTotalIndemnisation(pp + pe + pm + it + atp + pd + pes + ps + pc + pl + parseFloat(offre?.montantFraisMedicaux));
        }

        if (victimized?.decesSinistre) {
            let nbreCjts = victimized?.ayantsDroit?.filter((ad) => isPartnerQualite(ad.qualite)).length;
            setNbreConjoints(nbreCjts);
            let conjointKey = getPourcentageRepartition(victimized?.situationFamilialeDefunt, "conjoint");
            let revCapCjt = nbreCjts ? ((victimized?.revenuProfessionelMensuelAvantAccident || 0.0) * (conjointKey) * 12 / 100) / nbreCjts : 0.0;
            setRevenuACapitaliserDesCoinjoints(revCapCjt);
            setCleDesCoinjoints(conjointKey);
            let nbreAscendants = victimized?.ayantsDroit?.filter((ad) => ad.qualite.toUpperCase().startsWith("PERE") || ad.qualite.toUpperCase().startsWith("MERE")).length || 0;
            let ascendantsKey = getPourcentageRepartition(victimized?.situationFamilialeDefunt, "ascendant");
            let revCapAscendants = nbreAscendants ? ((victimized?.revenuProfessionelMensuelAvantAccident || 0.0) * (ascendantsKey) * 12 / 100) / nbreAscendants : 0.0;
            setRevenuACapitaliserDesAscendants(revCapAscendants);
            let nbreOrphelins = victimized?.ayantsDroit?.filter((ad) => (ad.qualite.toUpperCase().startsWith("ENFANT MINEUR") || ad.qualite.toUpperCase().startsWith("ENFANT_MINEUR"))).length || 0;
            let orphelinsKey = getPourcentageRepartition(victimized?.situationFamilialeDefunt, "enfant");
            console.log("Nbre orphelins: ", nbreOrphelins, " OrphelinsKey: ", orphelinsKey, " Rev pro mensuel avant accident: ", victimized?.revenuProfessionelMensuelAvantAccident, " Smig: ", smig);
            let revCapOrphelins = nbreOrphelins ? ((victimized?.revenuProfessionelMensuelAvantAccident || smig) * orphelinsKey * 12 / 100) / nbreOrphelins : 0.0;
            setRevenuACapitaliserDesEnfants(revCapOrphelins);
            let tPe = revCapCjt * nbreCjts + revCapAscendants * nbreAscendants + revCapOrphelins * nbreOrphelins;
            setPrejudiceEconomique(tPe);
            setPlafondPrejudiceEconomiqueAD(12 * smig * 85);
            setPlafondPrejudiceMoralAD(smig * 20 * 12);
            setPlafondPrejudiceMoralVeuveAD(smig * 6 * 12);

            let tPmV = 0.0;
            let tpm = 0.0;
            let tot = 0.0;
            victimized?.ayantsDroit?.forEach((ad) => {
                let clefPM = ad?.qualite?.startsWith("CONCUBIN") ? getAgeFromSinistre(ad?.dateNaissance, props?.sinistre?.dateSinistre) > 18 ? getPrejudiceMoralBeneficiaireKey("ENFANT MAJEUR") / 100 : getPrejudiceMoralBeneficiaireKey("ENFANT MINEUR") / 100 : getPrejudiceMoralBeneficiaireKey(ad?.qualite) / 100;
                let plaf = isPartnerQualite(ad?.qualite) ? (smig * 6 * 12) : (smig * 20 * 12);
                let pm = Math.min(smig * 12 * clefPM, plaf);
                console.log("AD " + ad?.codeId + " Qualite: ", ad?.qualite, " ClefPM: ", clefPM, " Plaf: ", plaf, " PM: ", pm);
                if (isPartnerQualite(ad.qualite) && ad?.genre?.toUpperCase() === "FEMININ") {
                    tPmV += pm;
                }
                tpm += pm;
            });

            setPrejudiceMoral(tpm);
            setTotalPrejudiceMoralVeuveAD(tPmV);
            let totalPe = 0.0;
            let totalPm = 0.0;
            let ayds = [];
            for (const ad of victimized?.ayantsDroit || []) {
                const quality = ad?.qualite?.toUpperCase().startsWith("PERE") || ad?.qualite.toUpperCase().startsWith("MERE") ? 100 : ad?.qualite?.startsWith("ENFANT") ? 25 : isPartnerQualite(ad?.qualite) ? 100 : 0;
                console.log("Birthdayyy: ", getAgeFromSinistre(ad?.dateNaissance, props?.sinistre?.dateSinistre));
                let prixRente = await getPrixRente(getAgeFromSinistre(ad?.dateNaissance, props?.sinistre?.dateSinistre), ad?.genre, quality);

                let rac = (ad?.qualite === "PERE" || ad?.qualite === "MERE")
                    ? revCapAscendants
                    : ad?.qualite?.startsWith("ENFANT")
                        ? revCapOrphelins
                        : isPartnerQualite(ad?.qualite)
                            ? revCapCjt
                            : 0;

                let clefPM = ad?.qualite?.startsWith("CONCUBIN") ? getAgeFromSinistre(ad?.dateNaissance, props?.sinistre?.dateSinistre) > 18 ? getPrejudiceMoralBeneficiaireKey("ENFANT MAJEUR") / 100 : getPrejudiceMoralBeneficiaireKey("ENFANT MINEUR") / 100 : getPrejudiceMoralBeneficiaireKey(ad?.qualite) / 100;

                let aDroit = (ad?.qualite === "PERE" || ad?.qualite === "MERE") ? "ascendant" : ad?.qualite?.startsWith("ENFANT") ? ad?.typeOrphelin === "ORPHELIN DOUBLE" ? "orphelinDouble" : "enfant" : isPartnerQualite(ad?.qualite) ? "conjoint" : null;

                let cumulPM = isPartnerQualite(ad?.qualite) && aDroit?.genre?.toUpperCase() === "FEMININ" ? tPmV : tpm;
                let plaf = isPartnerQualite(ad?.qualite) && aDroit?.genre?.toUpperCase() === "FEMININ"
                    ? (smig * 6 * 12)
                    : (smig * 20 * 12);

                let plafEco = 12 * smig * 85;
                console.log("Cumul PM222: ", cumulPM, " Plaf: ", plaf, " ClefPM: ", clefPM, " Smig: ", smig);
                let pm = cumulPM > plaf
                    ? (plaf * Math.min(smig * 12 * (clefPM), plaf) / cumulPM)
                    : Math.min(smig * 12 * (clefPM), plaf);

                console.log("Details on pe: AD ", ad?.qualite, " Rac: ", rac, " Prix rente: ", prixRente, " PlafEco: ", plafEco, "TPE: ", tPe, " PM: ", pm);
                let pe = Math.min(rac * prixRente, (tPe ? (plafEco * rac * prixRente / tPe) : 0));
                console.log("Pour AD ", ad?.qualite, " Rac: ", rac, " PM: ", pm, " PE: ", pe);
                // tot += rac + pm + pe;
                tot += pm + pe;
                totalPe += pe;
                totalPm += pm;
                ad.totalIndemnisation = pe + pm;
                ayds.push({ ...ad, montantPrejudiceEconomique: pe, montantPrejudiceMoral: pm, totalIndemnisation: ad.totalIndemnisation });
            }
            // console.log("Total indemnisation: ", tot);
            setAyantsDroits(ayds);
            setTotalIndemnisation(tot);
            setTotalPrejudiceEconomique(totalPe);
            setTotalPrejudiceMoral(totalPm);
        }
        const plafondFraisFuneraires = 2 * smig * 12;
        if (offre?.montantFraisFuneraires > plafondFraisFuneraires) {
            toast("Le montant des frais funeraires est supérieur au plafond autorisé!");
            setOffre({ ...offre, montantFraisFuneraires: plafondFraisFuneraires });
        }
    }

    useEffect(() => {
        setResponsabilite(props?.sinistre?.tauxResponsabilite ? props?.sinistre?.tauxResponsabilite : 100);
        if (victime && victime?.personne) {
            dealWithOffer(victime);
        }

    }, [props.expertises, expertise, offre?.montantFraisMedicaux, offre?.montantFraisFuneraires, smig, victime, responsabilite]);

    const expertisePretiumLabel = useMemo(
        () => findPretiumLabel(pretiumDolorisOptions, expertise?.pretiumDoloris),
        [pretiumDolorisOptions, expertise?.pretiumDoloris]
    );


    return (
        <Modal
            title={props.edit ? "Modifier une offre" : "Ajouter une offre"}
            centered
            open={isOffreModalVisible}
            onOk={() => handleSubmit()}
            onCancel={() => setIsOffreModalVisible(false)}
            loading={addOffreLoading}
            confirmLoading={addOffreLoading}
            width="95vw"
            style={{ maxWidth: '1600px' }}
            okText={props.edit ? "Modifier" : "Ajouter"}
            cancelText="Annuler"
            zIndex={2000}
            okButtonProps={{ style: { background: '#242166' } }}
        >
            {/* Styles pour rendre les tableaux responsifs */}
            <style>{`
                .offre-modal-table {
                    table-layout: fixed;
                    width: 100%;
                }
                .offre-modal-table th,
                .offre-modal-table td {
                    font-size: 10px;
                    padding: 3px 4px !important;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: normal;       /* permet le retour à la ligne */
                    word-wrap: break-word;
                    vertical-align: middle;
                    text-align: center;
                }
                .offre-modal-table thead th {
                    font-size: 9px;
                    text-transform: uppercase;
                    white-space: normal;       /* headers sur 2 lignes si besoin */
                    line-height: 1.2;
                }
                .offre-modal-provisions th,
                .offre-modal-provisions td {
                    font-size: 12px;
                    padding: 6px 8px !important;
                }
            `}</style>
            <div className="row">
                <div className="col-6">
                    <label
                        htmlFor="victime"
                        style={{
                            margin: "30px 0 10px 0",
                        }}
                    >
                        Selectionner la victime :
                    </label>
                    <Select
                        id="victime"
                        name="victime"
                        style={{ width: "100%" }}
                        placeholder="Sélectionnez la victime"
                        options={victimes?.map((item) => ({
                            value: JSON.stringify(item),
                            label: `${item?.personne?.nom} ${item?.personne?.prenom}`,
                            data: item
                        }))}
                        value={JSON.stringify(offre?.victime)}
                        onChange={(value, option) => {
                            if (!option?.data?.personne?.dateNaissance) {
                                toast.error("La victime doit avoir une date de naissance");
                            } else {
                                setVictime(option?.data);
                                setExpertise(expertises.find((exp) => exp?.beneficiaire?.codeId === option?.data?.codeId));
                                console.log(option?.data);
                                handleChange(JSON.parse(value), "victime");
                            }

                        }}
                    />
                </div>
                <div className="col-6">
                    <label
                        htmlFor="montantFraisMedicaux"
                        style={{
                            margin: "30px 0 10px 0",
                            color: null,
                        }}
                    > Montant des frais médicaux
                    </label>
                    <AmountInputNumber
                        placeholder={`Montant des frais médicaux`}
                        name={"montantFraisMedicaux"}
                        value={offre?.montantFraisMedicaux}
                        onChange={(value) => handleChange(value ?? 0, "montantFraisMedicaux")}
                        style={{ width: "100%" }}
                    />
                </div>
                {victime?.decesSinistre ? <div className="col-6">
                    <label
                        htmlFor="montantFraisFuneraires"
                        style={{
                            margin: "30px 0 10px 0",
                            color: null,
                        }}
                    > Montant des frais funéraires
                    </label>
                    <AmountInputNumber
                        placeholder={`Montant des frais funeraires`}
                        name={"montantFraisFuneraires"}
                        value={offre?.montantFraisFuneraires}
                        onChange={(value) => handleChange(value ?? 0, "montantFraisFuneraires")}
                        style={{ width: "100%" }}
                    />
                </div> : null}
                {/* Input date pour date de transmission du courrier */}
                <div className="col-6">
                    <label
                        htmlFor="dateCourrier"
                        style={{
                            margin: "30px 0 10px 0",
                            color: null,
                        }}
                    > Date de transmission du courrier
                    </label>
                    <DatePicker
                        id="dateCourrier"
                        name="dateCourrier"
                        style={{ width: "100%" }}
                        placeholder="Sélectionnez la date de transmission du courrier"
                        value={offre?.dateCourrier ? moment(offre.dateCourrier) : null}
                        onChange={(date, dateString) => handleChange(dateString, "dateCourrier")}
                        disabledDate={(current) => {
                            // Disable dates after today
                            return current && current < moment().startOf('day');
                        }}
                    />
                </div>
                {victime?.blesseSinistre ?
                    <Descriptions
                        title="Détails de l'Expertise"
                        bordered
                        column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}
                    >
                        <Descriptions.Item label="Objet de la mission" span={2}>
                            <Text strong>{expertise?.objetMission}</Text>
                        </Descriptions.Item>

                        <Descriptions.Item label="Victime">
                            {victime?.personne?.nom} {victime?.personne?.prenom}
                        </Descriptions.Item>

                        <Descriptions.Item label="Expert">
                            {expertise?.expert?.nom}
                        </Descriptions.Item>

                        <Descriptions.Item label="Type d'expertise">
                            <Tag color="geekblue">{expertise?.typeExpertise}</Tag>
                        </Descriptions.Item>

                        <Descriptions.Item label="Date de l'expertise">
                            {expertise?.dateExpertise}
                        </Descriptions.Item>

                        <Descriptions.Item label={`ITT (${getIttUnitLabel(expertise?.ittUnit)})`}>
                            <Text strong>{formatIttValueForDisplay(expertise?.itt, expertise?.ittUnit)}</Text>
                        </Descriptions.Item>

                        <Descriptions.Item label="Taux IPP (%)">
                            <Text strong>{expertise?.ipp || 0}</Text>
                        </Descriptions.Item>

                        <Descriptions.Item label="Pretium Doloris">
                            <Tag color="orange">{expertisePretiumLabel || expertise?.pretiumDoloris || '-'}</Tag>
                        </Descriptions.Item>

                        <Descriptions.Item label="Préjudice Esthétique">
                            <Tag color="purple">{
                                [
                                    { value: 0, label: "Néant" },
                                    { value: 5, label: "Très léger" },
                                    { value: 10, label: "Léger" },
                                    { value: 20, label: "Modéré" },
                                    { value: 40, label: "Moyen" },
                                    { value: 60, label: "Assez Important" },
                                    { value: 100, label: "Important" },
                                    { value: 150, label: "Très important" },
                                    { value: 300, label: "Exceptionnel" },
                                ].find(opt => opt.value === expertise?.prejudiceEsthetique)?.label
                            }</Tag>
                        </Descriptions.Item>

                        <Descriptions.Item label="Besoin d'assistance">
                            <Tag color={expertise?.besoinAssistance ? 'green' : 'red'}>
                                {expertise?.besoinAssistance ? "OUI" : "NON"}
                            </Tag>
                        </Descriptions.Item>

                        <Descriptions.Item label="Préjudice de carrière">
                            <Tag color={expertise?.prejudiceCarriere ? 'green' : 'red'}>
                                {expertise?.prejudiceCarriere ? "OUI" : "NON"}
                            </Tag>
                        </Descriptions.Item>

                        <Descriptions.Item label="Commentaire" span={2}>
                            {expertise?.commentaire || "Aucun commentaire."}
                        </Descriptions.Item>

                        <Descriptions.Item label="Rapport" span={2}>
                            <a href={`/path-to-report/${expertise?.rapportName}`} target="_blank" rel="noopener noreferrer">
                                <UploadOutlined /> Voir le rapport
                            </a>
                        </Descriptions.Item>
                    </Descriptions> : null}

                {/* Displays all provisions in a table */}
                {provisions && provisions.length ? <div className="container mt-4">
                    <h3>Provisions</h3>
                    <div className="table-responsive">
                        <table className="table table-bordered offre-modal-provisions">
                            <thead className="table-dark">
                                <tr>
                                    <th scope="col" className="text-center">DATE REGLEMENT</th>
                                    <th scope="col" className="text-center">MONTANT</th>
                                </tr>
                            </thead>
                            <tbody> {provisions.map((provision, index) => (
                                <tr key={index}>
                                    <td>{frenchDate(provision?.dateReglement) || "-"}</td>
                                    <td>{displayNumbers(provision?.montantGlobal) || 0} {provision?.numeroCheque ? `Chèque N° ${provision?.numeroCheque} - ${provision?.banque}` : ""} </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div> : null}

                {victime?.blesseSinistre ? <div className="container mt-4">
                    <div>
                        <table className="table table-bordered offre-modal-table">
                            <thead className="table-dark">
                                <tr>
                                    <th scope="col" rowSpan="2" className="align-middle text-center" style={{ width: '30%' }}>PRÉJUDICES INDEMNISABLES</th>
                                    <th scope="col" colSpan="2" className="text-center">MONTANT</th>
                                </tr>
                                <tr>
                                    <th scope="col" className="text-center" style={{ width: '35%' }}>SANS PARTAGE DE RESP.</th>
                                    <th scope="col" className="text-center" style={{ width: '35%' }}>APRÈS PARTAGE DE RESP.</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Frais médicaux justifiés et autres frais (Art 258 CIMA)</td>
                                    <td>{displayNumbers(offre?.montantFraisMedicaux) || 0} </td>
                                    <td>{displayNumbers(offre?.montantFraisMedicaux * responsabilite / 100) || 0}</td>
                                </tr>
                                <tr>
                                    <td>Incapacité temporaire</td>
                                    <td>{victime?.perceptionSalairePendantTraitement ? 0 :
                                        displayNumbers(
                                            incapaciteTemporaire
                                        )}
                                    </td>
                                    <td>{victime?.perceptionSalairePendantTraitement ? 0 :
                                        displayNumbers(
                                            Math.trunc(incapaciteTemporaire * responsabilite / 100)
                                        )}</td>
                                </tr>
                                <tr className="table-secondary">
                                    <td colSpan="3" className="fw-bold">Incapacité permanente</td>
                                </tr>
                                <tr>
                                    <td className="ps-4"><i>Préjudice physiologique</i></td>
                                    <td>{displayNumbers(prejudicePhysiologique)} </td>
                                    <td>{displayNumbers(prejudicePhysiologique * responsabilite / 100)}</td>
                                </tr>
                                <tr>
                                    <td className="ps-4"><i>Préjudice économique</i></td>
                                    <td>{displayNumbers(prejudiceEconomique)} </td>
                                    <td>{displayNumbers(prejudiceEconomique * responsabilite / 100)}</td>
                                </tr>
                                <tr>
                                    <td className="ps-4"><i>Préjudice moral</i></td>
                                    <td>{expertise?.ipp > 80.0 ? displayNumbers(prejudiceMoral) : 0} </td>
                                    <td>{expertise?.ipp > 80.0 ? displayNumbers(prejudiceMoral * responsabilite / 100) : 0}</td>
                                </tr>
                                <tr className="table-secondary fw-bold">
                                    <td>Total incap. permanente (Art 260 CIMA)</td>
                                    <td>{displayNumbers(prejudiceEconomique + prejudicePhysiologique + prejudiceMoral)}</td>
                                    <td>{displayNumbers((prejudiceEconomique + prejudicePhysiologique + prejudiceMoral) * responsabilite / 100)}</td>
                                </tr>
                                <tr>
                                    <td>Assistance tierce personne (Art 261 CIMA)</td>
                                    <td>{displayNumbers(assistanceTiercePersonne)} </td>
                                    <td>{displayNumbers(assistanceTiercePersonne * responsabilite / 100)} </td>
                                </tr>
                                <tr>
                                    <td>Pretium Doloris (Art 262 CIMA)</td>
                                    <td>{displayNumbers(pretiumDoloris)} </td>
                                    <td>{displayNumbers(pretiumDoloris * responsabilite / 100)} </td>
                                </tr>
                                <tr>
                                    <td>Préjudice esthétique (Art 262 CIMA)</td>
                                    <td>{displayNumbers(prejudiceEsthetique)} </td>
                                    <td>{displayNumbers(prejudiceEsthetique * responsabilite / 100)} </td>
                                </tr>
                                <tr>
                                    <td>Préjudice scolaire (Art 263 CIMA)</td>
                                    <td>{displayNumbers(prejudiceScolaire)} </td>
                                    <td>{displayNumbers(prejudiceScolaire * responsabilite / 100)} </td>
                                </tr>
                                <tr>
                                    <td>Préjudice de carrière (Art 263 CIMA)</td>
                                    <td>{displayNumbers(prejudiceCarriere)} </td>
                                    <td>{displayNumbers(prejudiceCarriere * responsabilite / 100)} </td>
                                </tr>
                                <tr>
                                    <td>Préjudice des lésés à la charge effective de la victime</td>
                                    <td>{displayNumbers(prejudiceLeses)} </td>
                                    <td>{displayNumbers(prejudiceLeses * responsabilite / 100)} </td>
                                </tr>
                                <tr className="table-dark text-white fw-bold">
                                    <td>TOTAL DES INDEMNITÉS</td>
                                    <td>{displayNumbers(totalIndemnisation)} </td>
                                    <td>{displayNumbers(Math.trunc(totalIndemnisation * responsabilite / 100))} </td>
                                </tr>
                                <tr className="table-light fw-bold">
                                    <td>PROVISIONS À DÉDUIRE (-)</td>
                                    <td>{displayNumbers(totalProvisions)}</td>
                                    <td></td>
                                </tr>
                                <tr className="table-dark text-white fw-bold">
                                    <td colSpan={2}>TOTAL À PAYER</td>
                                    <td>{displayNumbers(Math.trunc((totalIndemnisation * responsabilite / 100) - totalProvisions))} </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div> : null}

                {victime?.decesSinistre ?
                    <div className="container-fluid mt-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="text-center flex-grow-1">
                                <h5>INDEMNISATION DES PREJUDICES SUBIS PAR LES AYANTS DROIT DE LA VICTIME DECEDEE</h5>
                            </div>
                        </div>

                        <div className="row info-section mb-4">
                            <div className="col-6">
                                <table className="table table-sm table-borderless">
                                    <tbody>
                                        <tr>
                                            <td className="fw-bold">SINISTRE</td>
                                            <td>{props?.sinistre?.numSinistre ? props?.sinistre?.numSinistre : props?.sinistre?.numeroSinistreM}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">DATE DE SURVENANCE</td>
                                            <td>{props?.sinistre?.dateSinistre && frenchDate(props?.sinistre?.dateSinistre)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">VICTIME DECEDEE</td>
                                            <td>{victime?.personne?.nom} {victime?.personne?.prenom}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">SITUATION FAMILIALE</td>
                                            <td>{victime?.situationFamilialeDefunt}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">TYPE D'ORPHELIN</td>
                                            <td>{victime?.typeOrphelin}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">REVENU ANNUEL / SMIG</td>
                                            <td>{displayNumbers(victime?.revenuProfessionelMensuelAvantAccident * 12)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">SMIG ANNUEL</td>
                                            <td>{displayNumbers(smig * 12)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-6">
                                <table className="table table-sm table-borderless">
                                    <tbody>
                                        <tr>
                                            <td className="fw-bold">NOMBRE D'ENFANT MINEUR</td>
                                            <td>{victime?.ayantsDroit?.filter((ad) => (ad.qualite.toUpperCase() === "ENFANT MINEUR" || ad.qualite.toUpperCase() === "ENFANT_MINEUR")).length}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">NOMBRE D'ENFANT MAJEUR</td>
                                            <td>{victime?.ayantsDroit?.filter((ad) => (ad.qualite.toUpperCase() === "ENFANT MAJEUR" || ad.qualite.toUpperCase() === "ENFANT_MAJEUR")).length}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">NOMBRE DE CONJOINTS</td>
                                            <td>{victime?.ayantsDroit?.filter((ad) => isPartnerQualite(ad.qualite)).length}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">NOMBRE D'ASCENDANT</td>
                                            <td>{victime?.ayantsDroit?.filter((ad) => ad.qualite.toUpperCase() === "PERE").length + victime?.ayantsDroit?.filter((ad) => ad.qualite.toUpperCase() === "MERE").length}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">NOMBRE DE FRERE ET SŒUR</td>
                                            <td>{victime?.ayantsDroit?.filter((ad) => ad.qualite.toUpperCase() === "FRERE").length + victime?.ayantsDroit?.filter((ad) => ad.qualite.toUpperCase() === "SOEUR").length}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">PLAFOND Préj. MORAL DES CONJOINT(ES)</td>
                                            <td>{displayNumbers(6 * smig * 12)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">PLAFOND Préjudice MORAL TOTAL</td>
                                            <td>{displayNumbers(20 * smig * 12)}</td>
                                        </tr>
                                        <tr>
                                            <td className="fw-bold">PLAFOND PREJUDICE ECONOMIQUE</td>
                                            <td>{displayNumbers(85 * smig * 12)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div>
                            <table className="table table-bordered table-sm offre-modal-table">
                                <thead className="table-dark text-white text-center">
                                    <tr>
                                        <th scope="col" rowSpan="2" className="align-middle text-start" style={{ width: '11%' }}>
                                            NOM & PRÉNOMS
                                        </th>
                                        <th scope="col" rowSpan="2" className="align-middle" style={{ width: '7%' }}>
                                            SEXE
                                        </th>
                                        <th scope="col" rowSpan="2" className="align-middle" style={{ width: '9%' }}>
                                            QUALITÉ
                                        </th>
                                        <th scope="col" rowSpan="2" className="align-middle" style={{ width: '8%' }}>
                                            DATE DE NAISSANCE
                                        </th>
                                        <th scope="col" rowSpan="2" className="align-middle" style={{ width: '4%' }}>
                                            ÂGE
                                        </th>
                                        <th scope="col" rowSpan="2" className="align-middle" style={{ width: '8%' }}>
                                            COEFFICIENT DE CAPITALISATION
                                        </th>
                                        <th scope="col" colSpan="2" className="align-middle" style={{ width: '10%' }}>
                                            CLÉ DE RÉPARTITION
                                        </th>
                                        <th scope="col" rowSpan="2" className="align-middle" style={{ width: '7%' }}>
                                            REVENU À CAPITALISER
                                        </th>
                                        <th scope="col" rowSpan="2" className="align-middle" style={{ width: '8%' }}>
                                            PRÉJUDICE ÉCONOMIQUE
                                        </th>
                                        <th scope="col" rowSpan="2" className="align-middle" style={{ width: '8%' }}>
                                            PRÉJUDICE MORAL
                                        </th>
                                        <th scope="col" rowSpan="2" className="align-middle" style={{ width: '10%' }}>
                                            TOTAL DES INDEMNITÉS À 100%
                                        </th>
                                        <th scope="col" rowSpan="2" className="align-middle" style={{ width: '10%' }}>
                                            TOTAL APRÈS PARTAGE À {responsabilite}%
                                        </th>
                                    </tr>
                                    <tr>
                                        <th scope="col" style={{ width: '4%' }}>P. Écon.</th>
                                        <th scope="col" style={{ width: '4%' }}>P. Moral</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {victime?.ayantsDroit?.map((ayantDroit, index) => {
                                        console.log("Age ayantDroit ", ayantDroit?.dateNaissance, " : ", getAgeFromSinistre(ayantDroit?.dateNaissance, props?.sinistre?.dateSinistre));

                                        const prixRente = prixRentesLoading ? 0 : prixRentes[index];
                                        let ad = (ayantDroit?.qualite === "PERE" || ayantDroit?.qualite === "MERE") ? "ascendant" : ayantDroit?.qualite?.startsWith("ENFANT") ? ayantDroit?.typeOrphelin === "ORPHELIN DOUBLE" ? "orphelinDouble" : "enfant" : isPartnerQualite(ayantDroit?.qualite) ? "conjoint" : null;
                                        let clefE = ad ? getPourcentageRepartition(victime?.situationFamilialeDefunt, ad) / 100 : 0;
                                        let clefPM = ayantDroit?.qualite?.startsWith("CONCUBIN") ? getAgeFromSinistre(ayantDroit?.dateNaissance, props?.sinistre?.dateSinistre) > 18 ? getPrejudiceMoralBeneficiaireKey("ENFANT MAJEUR") / 100 : getPrejudiceMoralBeneficiaireKey("ENFANT MINEUR") / 100 : getPrejudiceMoralBeneficiaireKey(ayantDroit?.qualite) / 100;
                                        let rac = (ayantDroit?.qualite === "PERE" || ayantDroit?.qualite === "MERE") ? revenuACapitaliserDesAscendants : (ayantDroit?.qualite?.startsWith("ENFANT MINEUR") || ayantDroit?.qualite?.startsWith("ENFANT_MINEUR")) ? revenuACapitaliserDesEnfants : isPartnerQualite(ayantDroit?.qualite) ? revenuACapitaliserDesCoinjoints : 0;
                                        let cumulPM = isPartnerQualite(ayantDroit?.qualite) && ad?.genre?.toUpperCase() === "FEMININ" ? totalPrejudiceMoralVeuveAD : prejudiceMoral;
                                        let plaf = isPartnerQualite(ayantDroit?.qualite) && ad?.genre?.toUpperCase() === "FEMININ" ? plafondPrejudiceMoralVeuveAD : plafondPrejudiceMoralAD;
                                        console.log("Cumul PM: ", cumulPM, " ", plaf);
                                        let pm = cumulPM > plaf ? (plaf * Math.min(smig * 12 * clefPM, plaf) / cumulPM) : Math.min(smig * 12 * clefPM, plaf);
                                        console.log("PMMMMM: ", pm, " clefPM: ", clefPM, " cumulPM: ", cumulPM, " plaf: ", plaf);
                                        let pe = prejudiceEconomique > plafondPrejudiceEconomiqueAD ? (plafondPrejudiceEconomiqueAD * rac * prixRente / prejudiceEconomique) : rac * prixRente;
                                        // let tot = rac + pm + pe;
                                        let tot = pm + pe;
                                        return (
                                            <tr key={index}>
                                                <td>{ayantDroit?.nom} {ayantDroit?.prenom}</td>
                                                <td>{ayantDroit?.genre}</td>           {/* SEXE en 2e position */}
                                                <td>{ayantDroit?.qualite}</td>          {/* QUALITÉ en 3e */}
                                                <td>{ayantDroit?.dateNaissance}</td>
                                                <td>{getAgeFromSinistre(ayantDroit?.dateNaissance, props?.sinistre?.dateSinistre)}</td>
                                                <td>{prixRente}</td>
                                                <td>{clefE * 100}</td>
                                                <td>{clefPM * 100}</td>
                                                <td>{rac ? displayNumbers(rac) : '0'}</td>
                                                <td>{rac && prixRente ? displayNumbers(pe) : 0}</td>
                                                <td>{clefPM ? displayNumbers(pm) : '0'}</td>
                                                <td>{tot ? displayNumbers(tot) : 0}</td>
                                                <td>{tot ? displayNumbers((props?.sinistre?.tauxResponsabilite ? props?.sinistre?.tauxResponsabilite * tot : 100.00 * tot) / 100) : 0}</td>
                                            </tr>
                                        )
                                    })}
                                    <tr style={{ height: "10px" }}></tr>
                                    <tr style={{ height: "10px" }}></tr>
                                    <tr className="table-dark text-white fw-bold">
                                        <td colSpan="9" className="text-end">TOTAL DES INDEMNITÉS</td>
                                        <td>{totalPrejudiceEconomique ? displayNumbers(totalPrejudiceEconomique) : 0} </td>
                                        <td>{totalPrejudiceMoral ? displayNumbers(totalPrejudiceMoral) : 0} </td>
                                        <td>{totalIndemnisation ? displayNumbers(totalIndemnisation) : 0}</td>
                                        <td>{totalIndemnisation ? displayNumbers(totalIndemnisation * (props?.sinistre?.tauxResponsabilite ? props?.sinistre?.tauxResponsabilite : 100) / 100) : 0} </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="8" className="text-end fw-bold">FRAIS FUNÉRAIRES JUSTIFIÉS</td>
                                        <td>{offre?.montantFraisFuneraires ? displayNumbers(offre?.montantFraisFuneraires) : 0.0}</td>
                                        <td colSpan="2" className="text-end fw-bold">FRAIS FUN. À REMBOURSER (+)</td>
                                        <td>{offre?.montantFraisFuneraires ? displayNumbers(offre?.montantFraisFuneraires) : 0.0}</td>
                                        <td>{offre?.montantFraisFuneraires ? displayNumbers((offre?.montantFraisFuneraires * (props?.sinistre?.tauxResponsabilite ? props?.sinistre?.tauxResponsabilite : 100) / 100)) : 0.0}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="8" className="text-end fw-bold">TAUX DE RESPONSABILITÉ DU POOL</td>
                                        <td>{props?.sinistre?.tauxResponsabilite ? props?.sinistre?.tauxResponsabilite : 100.00}%</td>
                                        <td colSpan="2" className="text-end fw-bold">FRAIS MÉDICAUX JUSTIFIÉS (+)</td>
                                        <td>{offre?.montantFraisMedicaux ? displayNumbers(offre?.montantFraisMedicaux) : 0.0} </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="11" className="text-end fw-bold">PROVISION À DÉDUIRE (-)</td>
                                        <td>{totalProvisions ? displayNumbers(totalProvisions) : 0.0} </td>
                                    </tr>
                                    <tr className="table-dark text-white fw-bold">
                                        <td colSpan="11" className="text-end">TOTAL À PAYER</td><td></td>
                                        <td>{displayNumbers(totalAPayer)} </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div> : null}
                <div className="col-12">
                    <label
                        htmlFor="description"
                        style={{
                            margin: "30px 0 10px 0",
                        }}
                    >
                        Description / commentaire :
                    </label>
                    <TextArea
                        id="description"
                        name="description"
                        value={offre?.description}
                        placeholder="Commentaire de l'offre"
                        onChange={(event) => {
                            handleChange(event);
                        }}
                        rows={4}
                    />
                </div>
                <br />
                <br />
                <br />

            </div>
        </Modal>
    )
}

AjouterOffre.propTypes = {
    open: PropTypes.bool,
    offre: PropTypes.object,
    expertises: PropTypes.array,
    edit: PropTypes.bool,
    setOpen: PropTypes.func,
    sinistre: PropTypes.object,
};

export default AjouterOffre
